import { fetchPost, rootApi, fetchGet } from '../helpers/api';

const errorReportApi = `${rootApi}/error-reports`;

export const createErrorReport = errorReport => fetchPost(errorReportApi, errorReport);

export const closeErrorReport = errorReportId => fetchGet(`${errorReportApi}/close/${errorReportId}`);

export const reopenErrorReport = errorReportId => fetchGet(`${errorReportApi}/open/${errorReportId}`);

export const searchErrorReport = cri => fetchPost(`${errorReportApi}/search`, cri);